import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { Modal, Image, Button, Form } from "react-bootstrap";
import Scrollbars from "react-custom-scrollbars";
import Media from "react-media";
import LeftSideNavigation from "../../../../vendorDashboardComponents/navigationSection/LeftSideNavigation";
import HomeReusableTopBarNavigation from "../../../superAdminReusable/superAdminHomeButton/HomeReusableTopBarNavigation";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import {
  update_vendor_profile,
  logOutUser,
} from "../../../../../store/actions/authAction";
import { superadmin_create_and_update_restaurant } from "../../../../../store/actions/SuperAdminActions/adminNewVendorOnboard";
//import isEmpty from "../../../../store/validation/is-Empty";

export const AdminTermsAndConditions = (props) => {
  let history = useHistory();
  let dispatch = useDispatch();
  //state
  const [showSuccess, setShowSuccess] = useState(false);
  const handleSubmit = () => setShowSuccess(true);
  const handleCloseSuccess = () => setShowSuccess(false);

  const [state, setState] = useState({
    vendor_id: "",
  });

  useEffect(() => {
    let adminVendorId = props?.editDataAction
      ? props?.editData?.vendor_id
      : JSON.parse(localStorage.getItem("vendorId"));
    const formData = {
      vendor_id: adminVendorId,
    };
    if (adminVendorId !== null || adminVendorId !== undefined) {
      setState({
        ...state,
        vendor_id: formData.vendor_id,
      });
    }
  }, []);

  const onSubScription = (e) => {
    let onboarding = props?.editDataAction
      ? props?.editData
      : props?.onboardingData;
    if (onboarding?._id && state?.vendor_id) {
      const formData = {
        vendor_id: state?.vendor_id,
        id: onboarding?._id,
        terms_and_condition_accepted: true,
      };
      dispatch(superadmin_create_and_update_restaurant(formData, onSuccess));
    }
  };

  const onSuccess = (e) => {
    const vendor_id = state?.vendor_id;
    const formData = {
      have_submited_details_yourself: false,
    };
    dispatch(update_vendor_profile(formData, vendor_id, callback));
  };

  const callback = (e) => {
    handleSubmit();
  };

  const onCombackLater = () => {
    dispatch(logOutUser());
    history.push("/");
  };

  return (
    <React.Fragment>
      <div className="container-fluid">
        <div className="row">
          <div className="left-side-panel">
            <LeftSideNavigation displayLink={1} />
          </div>
          <div className="super-admin-right-side-panel">
            <HomeReusableTopBarNavigation />
            <div className="col-6 pl-5 pr-5">
              <div className="super_admin_add_vendor mb-4">
                <h5 className="main_header_text">
                  {props?.editDataAction ? "Edit" : "Add"} Vendor
                </h5>
                {/* <h4 className="font_20_m">Step : 21</h4> */}
                <h4 className="font_20_m c_red mt-2 mb-1">
                  Terms And Conditions
                </h4>
                <hr className="hr_line" />
                <div className="TermBox">
                  <Scrollbars style={{ width: "100%", height: "100%" }}>
                    <div className="w-100 h-100 p-4">
                      <Media query="(min-width: 992px)">
                        <div className="pb-4">
                          <TopTextReusableComponent headingText="Terms And Conditions" />
                        </div>
                      </Media>
                      <div className="f13-500 mb-3">General Site Usage</div>
                      <div className="f12-400 mb-3">
                        Last Revised: December 16, 2020
                      </div>
                      <div className="f11-400 mb-3">
                        Welcome to Amealio This site is provided as a service to
                        our visitors and may be used for informational purposes
                        only. Because the Terms and Conditions contain legal
                        obligations, please read them carefully.
                      </div>
                      <div className="f13-700 mb-3">1. YOUR AGREEMENT</div>
                      <div className="f11-400 mb-3">
                        By using this Site, you agree to be bound by, and to
                        comply with, these Terms and Conditions. If you do not
                        agree to these Terms and Conditions, please do not use
                        this site.
                      </div>
                      <div className="f11-400 mb-3">
                        PLEASE NOTE: We reserve the right, at our sole
                        discretion, to change, modify or otherwise alter these
                        Terms and Conditions at any time. Unless otherwise
                        indicated, amendments will become effective immediately.
                        Please review these Terms and Conditions periodically.
                        Your continued use of the Site following the posting of
                        changes and/or modifications will constitute your
                        acceptance of the revised Terms and Conditions and the
                        reasonableness of these standards for notice of changes.
                        For your information, this page was last updated as of
                        the date at the top of these terms and conditions.
                      </div>
                      <div className="f13-700 mb-3">2. PRIVACY</div>
                      <div className="f11-400 mb-3">
                        Please review our Privacy Policy, which also governs
                        your visit to this Site, to understand our practices.
                      </div>
                      <div className="f13-700 mb-3">3. LINKED SITES</div>
                      <div className="f11-400 mb-3">
                        This Site may contain links to other independent
                        third-party Web sites ("Linked Sites”). These Linked
                        Sites are provided solely as a convenience to our
                        visitors. Such Linked Sites are not under our control,
                        and we are not responsible for and does not endorse the
                        content of such Linked Sites, including any information
                        or materials contained on such Linked Sites. You will
                        need to make your own independent judgment regarding
                        your interaction with these Linked Sites.
                      </div>
                      <div className="f13-700 mb-3">
                        4. FORWARD LOOKING STATEMENTS
                      </div>
                      <div className="f11-400 mb-3">
                        All materials reproduced on this site speak as of the
                        original date of publication or filing. The fact that a
                        document is available on this site does not mean that
                        the information contained in such document has not been
                        modified or superseded by events or by a subsequent
                        document or filing. We have no duty or policy to update
                        any information or statements contained on this site
                        and, therefore, such information or statements should
                        not be relied upon as being current as of the date you
                        access this site.
                      </div>
                      <div className="f13-700 mb-3">
                        5. DISCLAIMER OF WARRANTIES AND LIMITATION OF LIABILITY
                      </div>
                    </div>
                  </Scrollbars>
                </div>
                <div className="f12-400 mt-3 d-flex align-items-center">
                  <Form.Check label="1" inline className="enCheckBoxOnly" />I
                  have read the &nbsp;
                  <span className="text-blue"> terms and conditions </span>
                  &nbsp; of the agreement.
                </div>
                <div className="onboarding-map-setup-screen-autodetect-button mt-5">
                  <ReusableOnboardingLink
                    buttonTitle="Disagree Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Disagree"
                    link={
                      props?.editDataAction
                        ? "/admin_edit_bankdetails"
                        : "/addvendorbankdetails"
                    }
                  />
                  <ReusableOnboardingButton
                    buttonTitle="Agree Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                    buttonText="Agree"
                    buttonType="Submit"
                    onClick={onSubScription}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showSuccess}
        onHide={handleCloseSuccess}
        centered
        className="bg-yellow-modal"
      >
        <Modal.Header className="border-0" closeButton></Modal.Header>
        <Modal.Body className="text-center">
          <Image
            className="w-75 my-4"
            src={require("../../../../../assets/images/UserManagement/success2.png")}
          />
          <div className="f24_700_HelveticaNeue text-red text-center pb-4">
            Success!
          </div>
          <div className="f20-500 mobile-16">
            Thank You for Completing Your Profile.
          </div>
          <div className="f11-400 pb-3">
            We will get in touch with you by email in the next couple of days.
          </div>
          <div className="row">
            <div className="col-6">
              <Button
                variant="danger"
                className="w-100 btn-md py-2 mb-2 mobile-p-0"
                onClick={(e) =>
                  history.push(
                    props?.editDataAction
                      ? "/admin-edit-subscription"
                      : "/admin-subscription"
                  )
                }
              >
                Continue to Subscription
              </Button>
            </div>
            <div className="col-6">
              <Button
                variant="outline-secondary"
                className="w-100 btn-md py-2 mb-2  mobile-p-0"
                onClick={(e) => onCombackLater()}
              >
                Come Back Later to Complete
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

AdminTermsAndConditions.propTypes = {
  onboarding: PropTypes.object.isRequired,
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboardingData: state.superAdminOnboarding.restaurantDetails,
  editData: state?.adminAllVendorsInfo?.superAdminMerchantEditInfo,
  editDataAction:
    state?.adminAllVendorsInfo?.superAdminMerchantEditType?.editData,
});

export default connect(mapStateToProps, {
  superadmin_create_and_update_restaurant,
  update_vendor_profile,
  logOutUser,
})(withRouter(AdminTermsAndConditions));
